<nav class="app-navbar navbar py-3">
  <div class="container-fluid d-flex align-items-center justify-content-between">

    <a class="app-navbar__brand d-flex align-items-center gap-2 text-decoration-none" href="/">
      <img src="{{ logoUrl }}" alt="Logo" class="img-fluid" width="175" height="51">
    </a>

    <!-- Center Nav (desktop only) -->
    <div class="app-navbar__nav-pill d-none d-lg-flex align-items-center gap-1 bg-white rounded-pill px-3 py-2">
      <a routerLink="/" class="app-navbar__nav-link fw-medium rounded-pill px-2 py-1 text-decoration-none">Home</a>
      <a routerLink="/lost-and-found" class="app-navbar__nav-link fw-medium rounded-pill px-2 py-1 text-decoration-none">Lost &amp; Found</a>
      <a routerLink="/contact-us" class="app-navbar__nav-link fw-medium rounded-pill px-2 py-1 text-decoration-none">Contact us</a>

      <!-- Information Dropdown (desktop) -->
      <div ngbDropdown class="d-inline-block">
        <button class="app-navbar__nav-link app-navbar__nav-link--dropdown fw-medium rounded-pill px-2 py-1 text-decoration-none btn d-flex align-items-center gap-1"
                ngbDropdownToggle>
          Information
          <svg class="app-navbar__chevron"
               width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div ngbDropdownMenu class="app-navbar__dropdown-menu">
          <a ngbDropdownItem routerLink="/about">About us</a>
          <a ngbDropdownItem routerLink="/identi-professionals">Identi professionals</a>
          <a ngbDropdownItem routerLink="/microchipping-your-pet">Microchipping</a>
          <a ngbDropdownItem href="https://identicare.zendesk.com/hc/en-us">Help Centre</a>
          <a ngbDropdownItem href="https://identiblog.zendesk.com/hc/en-us">Blog</a>
        </div>
      </div>

      <a routerLink="/claim-pet" class="app-navbar__nav-link fw-medium rounded-pill px-2 py-1 text-decoration-none">Transfer of Keepership</a>
    </div>

    <div class="d-flex align-items-center gap-3">

      <a *ngIf="!authManager.isAuthenticated" routerLink="/login-register" class="app-navbar__login-btn btn rounded-pill px-4 py-2 fw-semibold d-none d-lg-inline-flex">Login</a>

      <div *ngIf="authManager.isAuthenticated" ngbDropdown class="d-none d-lg-inline-flex">
          <button class="app-navbar__nav-link app-navbar__nav-link--dropdown app-navbar__login-btn fw-medium rounded-pill ps-3 pe-2 py-2 text-decoration-none btn d-flex align-items-center gap-1" ngbDropdownToggle>
            Account
            <svg class="app-navbar__chevron"
                width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div ngbDropdownMenu class="app-navbar__dropdown-menu">
            <a ngbDropdownItem routerLink="/dashboard">Dashboard</a>
            <a ngbDropdownItem routerLink="/account">My account</a>
            <button
                type="button"
                (click)="authManager.logout()"
                ngbDropdownItem
            >
                Log out
            </button>
          </div>
      </div>

      <!-- Social icons -->
      <div class="app-navbar__social-icon-wrapper d-none d-lg-flex align-items-center gap-2">
        <app-social-facebook [badgeWrapperSize]="'24px'" [badgeIconSize]="'16px'"></app-social-facebook>
        <app-social-instagram [badgeWrapperSize]="'24px'" [badgeIconSize]="'16px'"></app-social-instagram>
        <app-social-twitter [badgeWrapperSize]="'24px'" [badgeIconSize]="'16px'"></app-social-twitter>
      </div>

      <!-- Hamburger (mobile only) -->
      <button
        class="app-navbar__toggler d-flex d-lg-none align-items-center justify-content-center btn"
        type="button"
        (click)="openMenu(mobileMenu)"
        aria-label="Open menu">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>

  </div>
</nav>

<!-- Banner details -->
<ng-container *appFeatureFlag="'isExtraBannerDetailsAvailable'">
  <div class="header-banner">
    <div *ngIf="bannersDetails && bannersDetails.length > 0 && isAnyBannerEnabled" class="header-banner__content container d-flex flex-column gap-1 align-items-center py-2">
      <div *ngFor="let bannerDetail of bannersDetails">
        <div
          class="header-banner__item rounded-3 text-center"
          *ngIf="bannerDetail.isEnabled"
          [ngStyle]="{
            'background-color': bannerDetail.color,
            'border-color': bannerDetail.color,
          }"
        >
          {{ bannerDetail.message }}
        </div>
      </div>
    </div>
    <ng-container *ngIf="authManager.isAuthenticated && authManager.isAdminImpersonating">
      <div class="container pb-3">
        <div class="alert alert-danger mb-0" role="alert">
          <p class="text-center mb-0">Caution! You are currently impersonating user: {{ userEmail }}</p>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<!-- Mobile Offcanvas Template -->
<ng-template #mobileMenu let-offcanvas>
  <div class="offcanvas-header app-navbar__offcanvas-header">
    <a class="app-navbar__brand d-flex align-items-center gap-2 text-decoration-none" routerLink="/">
      <img src="{{ logoUrl }}" alt="Logo" class="img-fluid" width="175" height="51">
    </a>
    <button type="button" class="btn-close" (click)="offcanvas.dismiss()" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body app-navbar__offcanvas-body d-flex flex-column gap-1 pt-2">
    <a routerLink="/" class="app-navbar__offcanvas-link fw-medium rounded-pill px-3 py-2 text-decoration-none" (click)="offcanvas.dismiss()">Home</a>
    <a routerLink="/lost-and-found" class="app-navbar__offcanvas-link fw-medium rounded-pill px-3 py-2 text-decoration-none" (click)="offcanvas.dismiss()">Lost &amp; Found</a>
    <a routerLink="/contact-us" class="app-navbar__offcanvas-link fw-medium rounded-pill px-3 py-2 text-decoration-none" (click)="offcanvas.dismiss()">Contact us</a>

    <!-- Information Accordion (mobile) -->
    <div>
      <button
        class="app-navbar__offcanvas-link app-navbar__offcanvas-link--toggle fw-medium rounded-pill px-3 py-2 text-decoration-none btn w-100 d-flex align-items-center justify-content-between"
        (click)="toggleInformation()">
        Information
        <svg class="app-navbar__chevron" [class.app-navbar__chevron--open]="isInformationOpen"
             width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <div #informationCollapse="ngbCollapse" [ngbCollapse]="!isInformationOpen">
        <div class="d-flex flex-column gap-1 ps-3 pt-1">
          <a routerLink="/about" class="app-navbar__offcanvas-sublink fw-medium rounded-pill px-3 py-2 text-decoration-none" (click)="offcanvas.dismiss()">About us</a>
          <a routerLink="/identi-professionals" class="app-navbar__offcanvas-sublink fw-medium rounded-pill px-3 py-2 text-decoration-none" (click)="offcanvas.dismiss()">Identi professionals</a>
          <a routerLink="/microchipping-your-pet" class="app-navbar__offcanvas-sublink fw-medium rounded-pill px-3 py-2 text-decoration-none" (click)="offcanvas.dismiss()">Microchipping</a>
          <a href="https://identicare.zendesk.com/hc/en-us" class="app-navbar__offcanvas-sublink fw-medium rounded-pill px-3 py-2 text-decoration-none" (click)="offcanvas.dismiss()">Help Centre</a>
          <a href="https://identiblog.zendesk.com/hc/en-us" class="app-navbar__offcanvas-sublink fw-medium rounded-pill px-3 py-2 text-decoration-none" (click)="offcanvas.dismiss()">Blog</a>
        </div>
      </div>
    </div>

    <a routerLink="/claim-pet" class="app-navbar__offcanvas-link fw-medium rounded-pill px-3 py-2 text-decoration-none" (click)="offcanvas.dismiss()">Transfer of Keepership</a>
 
    <div class="mt-2 py-3 border-top d-flex flex-column gap-3">
      <a *ngIf="!authManager.isAuthenticated" routerLink="/login-register" class="app-navbar__login-btn btn rounded-pill px-4 py-2 fw-semibold w-100" (click)="offcanvas.dismiss()">Login</a>
    
      <div *ngIf="authManager.isAuthenticated">
        <button
            class="app-navbar__offcanvas-link app-navbar__offcanvas-link--toggle fw-medium rounded-pill px-3 py-2 text-decoration-none btn w-100 d-flex align-items-center justify-content-between"
            (click)="toggleAccountMenu()">
            Account
            <svg class="app-navbar__chevron" [class.app-navbar__chevron--open]="isAccountMenuOpen"
                width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
        <div #accountCollapse="ngbCollapse" [ngbCollapse]="!isAccountMenuOpen">
            <div class="d-flex flex-column gap-1 ps-3 pt-1">
                <a routerLink="/dashboard" class="app-navbar__offcanvas-sublink fw-medium rounded-pill px-3 py-2 text-decoration-none" (click)="offcanvas.dismiss()">Dashboard</a>
                <a routerLink="/account" class="app-navbar__offcanvas-sublink fw-medium rounded-pill px-3 py-2 text-decoration-none" (click)="offcanvas.dismiss()">My account</a>
                <button
                    type="button"
                    class="app-navbar__offcanvas-sublink fw-medium rounded-pill px-3 py-2 text-decoration-none"
                    (click)="authManager.logout(); offcanvas.dismiss();"
                    ngbDropdownItem
                >
                    Log out
                </button>
            </div>
        </div>
        </div>
        
    </div>
    <div class="app-navbar__social-icon-wrapper mt-auto pt-3 border-top d-flex align-items-center justify-content-center gap-2 px-3">
      <app-social-facebook [badgeWrapperSize]="'24px'" [badgeIconSize]="'16px'"></app-social-facebook>
      <app-social-instagram [badgeWrapperSize]="'24px'" [badgeIconSize]="'16px'"></app-social-instagram>
      <app-social-twitter [badgeWrapperSize]="'24px'" [badgeIconSize]="'16px'"></app-social-twitter>
    </div>
  </div>
</ng-template>
